import { LoadablePaint } from '@confluence/loadable';

export const LabelsMovedChangeboardingLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LabelsMovedChangeboarding" */ '../src/LabelsMovedChangeboarding'
			)
		).LabelsMovedChangeboarding,
});
